import type { EmployeesParams } from 'providers/employees/useEmployees'
import { immer } from 'zustand/middleware/immer'

type Branch = {
  name: string
  branchIdentify: string
  document: string
  employeeCount: string
}

type Group = {
  name: string
  idWorkGroup: string
  branchIdentify: string
  employeeCount: string
}

type OrderByGroupStoreState = {
  branch: Branch
  group: Group
  totalEmployees: number
  errors: {
    branchIdentify: string
    idWorkGroup: string
  }
  filter: EmployeesParams
}

type OrderByGroupStoreActions = {
  updateBranch: (branch: Branch) => void
  updateGroup: (group: Group) => void
  updateFilter: (filter: EmployeesParams) => void
  updateErrors: (error: {
    branchIdentify?: string
    idWorkGroup?: string
  }) => void
  resetGroup: () => void
  resetFilter: () => void
  resetAllData: () => void
  updateTotalEmployees: (newValue: number) => void
}

export type OrderByGroupStore = OrderByGroupStoreState &
  OrderByGroupStoreActions

export const initialState: OrderByGroupStoreState = {
  branch: {
    name: '',
    branchIdentify: '',
    document: '',
    employeeCount: ''
  },
  group: {
    name: '',
    idWorkGroup: '',
    branchIdentify: '',
    employeeCount: ''
  },
  errors: {
    branchIdentify: '',
    idWorkGroup: ''
  },
  filter: {
    size: 10,
    page: 0,
    status: 'active'
  },
  totalEmployees: 0
}

export const orderByGroupStoreCreator = immer<OrderByGroupStore>((set) => ({
  ...initialState,
  updateBranch: (branch) => {
    set((state) => {
      state.branch = branch
    })
  },
  updateGroup: (group) => {
    set((state) => {
      state.group = group
    })
  },
  resetGroup: () => {
    set((state) => {
      state.group = initialState.group
    })
  },
  updateErrors: (error) => {
    set((state) => {
      state.errors = { ...state.errors, ...error }
    })
  },
  updateFilter: (filter) => {
    set((state) => {
      state.filter = { ...state.filter, ...filter }
    })
  },
  resetErrors: () => {
    set((state) => {
      state.errors = initialState.errors
    })
  },
  resetFilter: () => {
    set((state) => {
      state.filter = initialState.filter
    })
  },
  resetAllData: () => {
    set(() => ({ ...initialState }))
  },
  updateTotalEmployees(newValue) {
    set((state) => {
      state.totalEmployees = newValue
    })
  }
}))
